module.exports = __webpack_public_path__ + "static/media/feishu5.9b26700e.mp4";